import { useWindowSize } from "usehooks-ts";

import { useSelector } from "@/redux/hooks";
import { getUserAgent } from "@/redux/selectors/userAgent";

const MOBILE_WIDTH_THRESHOLD = 768;

const useIsMobileDetection = (mobileWidth = MOBILE_WIDTH_THRESHOLD) => {
  // detect mobile from user agent
  const { isMobile: isMobilePlatform } = useSelector(getUserAgent);
  // or allow desktop mobile styling
  const { width } = useWindowSize();
  const isMobileWidth = width < mobileWidth;

  return isMobilePlatform || isMobileWidth;
};

export default useIsMobileDetection;
